import React from 'react';
import DatePicker from 'react-datetime';

class SearchDate extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            value: this.props.value || this.props.defaultValue
        }
    }

    componentDidMount() {
        if(this.props.form && this.props.name) {
            this._unregisterFromForm = this.props.form.registerField(this);
        }
    }

    componentWillUnmount() {
        if (this._unregisterFromForm) {
            this._unregisterFromForm();
        }
    }

    componentWillReceiveProps(props) {
        if (typeof props.value != 'undefined') {
            this.setState({
                value: props.value
            });
        }
    }

    handleChange(val) {
        this.setState({
            value: val
        }, () => {
            if (this.props.form) {
                this.props.form.change();
            }
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(this.state.value);
            }
        });
    }

    get valid() {
        return this.props.required ? this.value : true;
    }

    get value() {
        return this.state.value;
    }

    setValue(val) {
        this.setState({
            value: val
        });
    }

    render () {
        let format = this.props.dateFormat || 'MM-DD-YYYY';
        let timeFormat = (typeof this.props.timeFormat !== 'undefined') ? this.props.timeFormat : false;
        let inputProps = Object.assign({
            name: this.props.name,
            placeholder: this.props.placeholder
        }, this.props.inputProps, {
            className: ['search-date-input', (this.props.inputProps || {}).className].join(' ')
        });

        return (
            <DatePicker {...this.props} inputProps={inputProps} onChange={(val) => this.handleChange(val)} dateFormat={format} value={this.state.value} timeFormat={timeFormat} className={['component-search-date', 'search-border', this.props.className].join(' ')} />
        )
    }
}

export default SearchDate;



// WEBPACK FOOTER //
// ./web-app/components/search-date.jsx